import React from 'react';
import { Box, Heading, Text, Button, Center, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Center h="100vh">
      <VStack spacing={6} textAlign="center">
        <Heading as="h1" size="2xl">
          404
        </Heading>
        <Text fontSize="xl">{t('errors.pageNotFound')}</Text>
        <Text>{t('errors.pageNotFoundDescription')}</Text>
        <Button
          as={RouterLink}
          to="/"
          colorScheme="blue"
          bg="brand.500"
          _hover={{ bg: 'brand.600' }}
        >
          {t('errors.goToDashboard')}
        </Button>
      </VStack>
    </Center>
  );
};

export default NotFound; 